<script setup>
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import SuporteAmshiftAPI from 'dashboard/api/suporteAmshift';
import Button from 'dashboard/components-next/button/Button.vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import SituacaoDoChamado from './SituacaoDoChamado.vue';
import { formatarDataHora, mensagemDoErro } from './helpers';

defineProps({
  podeVerEmpresa: { type: Boolean, default: false },
});

const emit = defineEmits(['abrir']);

const { t, locale } = useI18n();

const chamados = ref([]);
const carregando = ref(true);
const erro = ref('');
const daEmpresa = ref(false);

const carregar = async () => {
  carregando.value = true;
  erro.value = '';
  try {
    const { data } = await SuporteAmshiftAPI.listarChamados({
      todos: daEmpresa.value,
    });
    chamados.value = data.itens || [];
  } catch (e) {
    erro.value = mensagemDoErro(e, t('SUPORTE_AMSHIFT.ERRO.GENERICO'));
  } finally {
    carregando.value = false;
  }
};

watch(daEmpresa, carregar);
onMounted(carregar);
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex items-center justify-between gap-2">
      <label
        v-if="podeVerEmpresa"
        class="flex items-center gap-2 text-sm text-n-slate-11"
      >
        <Checkbox v-model="daEmpresa" />
        {{ t('SUPORTE_AMSHIFT.LISTA.TODOS_DA_EMPRESA') }}
      </label>
      <Button
        type="button"
        icon="i-lucide-refresh-cw"
        variant="ghost"
        color="slate"
        size="sm"
        class="ltr:ml-auto rtl:mr-auto"
        :label="t('SUPORTE_AMSHIFT.LISTA.CARREGAR_DE_NOVO')"
        :disabled="carregando"
        @click="carregar"
      />
    </div>

    <div v-if="carregando" class="flex justify-center py-8"><Spinner /></div>
    <p
      v-else-if="erro"
      class="px-3 py-2 mb-0 text-sm rounded-lg bg-n-ruby-3 text-n-ruby-11"
    >
      {{ erro }}
    </p>
    <p
      v-else-if="!chamados.length"
      class="py-8 mb-0 text-sm text-center text-n-slate-11"
    >
      {{ t('SUPORTE_AMSHIFT.LISTA.VAZIA') }}
    </p>
    <ul v-else class="flex flex-col gap-1 overflow-y-auto max-h-[50vh]">
      <li v-for="chamado in chamados" :key="chamado.numero">
        <button
          type="button"
          class="flex flex-col w-full gap-1 px-3 py-2 text-left rounded-lg sm:flex-row sm:items-center sm:justify-between hover:bg-n-alpha-1"
          @click="emit('abrir', chamado.numero)"
        >
          <span class="flex flex-col min-w-0">
            <span class="text-sm truncate text-n-slate-12">
              <span class="text-n-slate-10">#{{ chamado.numero }}</span>
              {{ chamado.titulo }}
            </span>
            <span class="text-xs text-n-slate-10">
              {{ chamado.solicitante?.nome }} ·
              {{ formatarDataHora(chamado.criadoEm, locale) }}
            </span>
          </span>
          <SituacaoDoChamado :chamado="chamado" />
        </button>
      </li>
    </ul>
  </div>
</template>
